import { render, staticRenderFns } from "./ListFooter.vue?vue&type=template&id=2381bc8f&scoped=true"
import script from "./ListFooter.vue?vue&type=script&lang=js"
export * from "./ListFooter.vue?vue&type=script&lang=js"
import style0 from "./ListFooter.vue?vue&type=style&index=0&id=2381bc8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381bc8f",
  null
  
)

export default component.exports